























import { Component, Vue } from 'vue-property-decorator';

import Tours from './components/Tours.vue';
import Extras from './components/Extras.vue';

@Component({
    components: {
        Tours,
        Extras
    }
})
export default class App extends Vue {
    private display = false;
    private data: any = {};
    private type: string = 'rent';
    private extras: Array<any> = [];
    private openExtras: boolean = false;
    private ajax: { method: string; action: string };
    private cancel: boolean = false;
    private save: boolean = false;
    private body: any = {};

    get hasExtras(): boolean {
        return this.extras.length > 0;
    }

    get title(): string {
        let string = `${this.type}_title`;
        if (this.openExtras) {
            string = 'extras_title';
        }
        return string;
    }

    get showExtras(): boolean {
        return this.hasExtras && this.openExtras;
    }

    public init(type: string, axios: { method: string; action: string }, body: any) {
        this.type = type;
        this.ajax = axios;
        this.body = body;
    }

    public open() {
        this.display = true;
        this.extras = (window as any).$extras;
        return new Promise((resolve, reject) => {
            let close = false;
            const loop = window.setInterval(() => {
                try {
                    if (this.save) {
                        close = true;
                        resolve(this.data);
                    } else if (this.cancel) {
                        close = true;
                        reject('cancel');
                    }
                } catch (e) {
                    close = true;
                    reject(e);
                }

                if (close) {
                    window.clearInterval(loop);
                    this.display = false;
                    this.reset();
                }
            });
        });
    }

    protected reset() {
        this.display = false;
        this.data = {};
        this.type = 'rent';
        this.extras = [];
        this.openExtras = false;
        this.cancel = false;
        this.save = false;
    }

    protected getData(data: any) {
        this.data = data;
    }

    protected getExtras(extras: Array<string>) {
        this.$set(this.data, 'extras', extras);
    }

    protected next() {
        this.openExtras = true;
    }

    protected submit() {
        //this.save = true;
        const data = { ...this.body, attributes: this.data };
        this.$groovie
            .post(this.ajax.action, data)
            .then(data => {
                this.save = true;
                console.log('data', data);
            })
            .catch(error => {
                console.error(error);
                this.cancel = true;
            });
    }
}
